export function FeedbackSkeleton() {
  return (
    <div className="min-h-screen bg-canvas">
      {/* Header Skeleton */}
      <div className="visitor-header">
        <div className="relative z-10 px-5 py-6">
          {/* Logo placeholder */}
          <div className="flex items-center gap-2 mb-4">
            <div className="w-6 h-6 rounded-lg skeleton" />
            <div className="w-16 h-3 rounded skeleton" />
          </div>

          {/* Amenity info skeleton */}
          <div className="flex items-start gap-4">
            <div className="w-14 h-14 rounded-2xl skeleton opacity-20" />
            <div className="flex-1 space-y-2">
              <div className="h-6 w-40 rounded skeleton opacity-20" />
              <div className="h-4 w-32 rounded skeleton opacity-20" />
            </div>
          </div>
        </div>
      </div>

      {/* Main content skeleton */}
      <div className="px-4 py-5">
        {/* Instruction skeleton */}
        <div className="flex items-center gap-2 mb-4">
          <div className="w-5 h-5 rounded-full skeleton" />
          <div className="h-4 w-48 rounded skeleton" />
        </div>

        {/* Category skeleton */}
        <div className="mb-6">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-3.5 h-3.5 rounded skeleton" />
            <div className="h-3 w-16 rounded skeleton" />
          </div>

          {/* Status cards grid */}
          <div className="grid grid-cols-3 gap-3">
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="bg-white rounded-2xl p-3 flex flex-col items-center justify-center min-h-[108px]"
                style={{
                  boxShadow: 'var(--shadow-sm)',
                  animationDelay: `${i * 100}ms`,
                }}
              >
                <div className="w-11 h-11 rounded-xl skeleton mb-2" />
                <div className="h-3 w-14 rounded skeleton mb-2" />
                <div className="h-4 w-12 rounded-full skeleton" />
              </div>
            ))}
          </div>
        </div>

        {/* Second category */}
        <div className="mb-6">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-3.5 h-3.5 rounded skeleton" />
            <div className="h-3 w-20 rounded skeleton" />
          </div>

          <div className="grid grid-cols-3 gap-3">
            {[1, 2].map((i) => (
              <div
                key={i}
                className="bg-white rounded-2xl p-3 flex flex-col items-center justify-center min-h-[108px]"
                style={{
                  boxShadow: 'var(--shadow-sm)',
                  animationDelay: `${(i + 3) * 100}ms`,
                }}
              >
                <div className="w-11 h-11 rounded-xl skeleton mb-2" />
                <div className="h-3 w-14 rounded skeleton mb-2" />
                <div className="h-4 w-12 rounded-full skeleton" />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Rating section skeleton */}
      <div className="px-4 pb-4">
        <div className="rating-section">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-5 h-5 rounded-full skeleton" />
            <div className="h-4 w-32 rounded skeleton" />
            <div className="h-3 w-14 rounded skeleton ms-auto" />
          </div>

          <div className="flex justify-center gap-2">
            {[1, 2, 3, 4, 5].map((i) => (
              <div
                key={i}
                className="w-10 h-10 rounded-xl skeleton"
                style={{ animationDelay: `${i * 50}ms` }}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Footer skeleton */}
      <div className="px-4 py-4">
        <div className="flex flex-col items-center gap-1">
          <div className="h-3 w-32 rounded skeleton" />
          <div className="h-3 w-48 rounded skeleton" />
        </div>
      </div>
    </div>
  );
}
